import(/* webpackMode: "eager" */ "/vercel/path0/app/ressurser/stresstest/page.tsx");
